import { combineReducers } from "redux";
import modalReducer from "./modal/modalReducer";
import userReducer from "./user/userReducer";

const RootReducer = combineReducers({
  user: userReducer, //user
  modal: modalReducer,
});

const rootReducer = (state, action) =>
  RootReducer(action.type === "Logout" ? undefined : state, action);
export default rootReducer;
